import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';

import logo from '../../../images/logoV2.png';
import ScrollToTop from '../../utils/ScrollToTop';
import Footer from './Footer';

export default ({ children }) => {
  function HeaderStyle() {
    return {
      marginBottom: '0px',
      top: '0px'
    };
  }

   return (
    <div>
      <Navbar
        collapseOnSelect
        fixedTop
        style={HeaderStyle()}
      >
        <Navbar.Header>
          <Navbar.Brand>
            <a href="https://korecki.ca">
              <img
                src={logo}
                alt="Korecki Real Estate Services"
              />
            </a>
          </Navbar.Brand>

          <Navbar.Toggle />
        </Navbar.Header>

        <Navbar.Collapse>
          <Nav>
          <li>
            <a href="https://korecki.ca">
              HOME
            </a>
          </li>

          <li>
            <a href="https://korecki.ca/strata-management-services">
              STRATA MANAGEMENT
            </a>
          </li>

          <li>
            <a href="https://korecki.ca/rental-management-services">
              RENTAL MANAGEMENT
            </a>
          </li>

          <li>
            <a href="https://korecki.ca/developers">
              DEVELOPER SERVICES
            </a>
          </li>

          <li>
            <a href="https://korecki.ca/documents">
              DOCUMENTS & FORMS
            </a>
          </li>

          <li>
            <a href="https://korecki.ca/listings">
              LISTINGS
            </a>
          </li>

          <li>
            <a href="https://korecki.ca/company">
              ABOUT
            </a>
          </li>

          <li>
            <a href="https://korecki.ca/contact">
              CONTACT
            </a>
          </li>

          <li>
            <a href="/login">
              LOGIN
            </a>
          </li>

        </Nav>
        </Navbar.Collapse>
      </Navbar>

      <ScrollToTop>
  <main>{children}</main>
</ScrollToTop>

<Footer />
    </div>
  );
};